class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0,null,document.activeElement.getAttribute('name'),null,this.dataset.key);
      setTimeout(() => {
        this.checkByobBundlesInCart();
      }, 1000);
    });
  }

  checkByobBundlesInCart() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(cart => {
        // Check if any BYOB bundle exists
        const hasByobBundle = cart.items.some(item => item.properties && item.properties._byob_products);
        console.log("hasByobBundlehasByobBundlehasByobBundle====",hasByobBundle);
        
        // Update the `order_type` attribute
        const attributes = hasByobBundle
          ? { order_type: 'byob' }
          : { order_type: '' };
          console.log("attributesattributesattributes===",attributes);
          
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ attributes }),
        });
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated after product removal:', data);
      })
      .catch(error => {
        console.error('Error handling product removal:', error);
      });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      if(!event.target.classList.contains('cart-discount')){      
        this.onChange(event);
      }
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    // console.log('event targte',event.target);
    if(event.target.id != 'cart-discount-input' && event.target.dataset.inputType == undefined){
      this.updateQuantity(event.target.dataset.index, event.target.value,event.target.dataset.sellingPlan, document.activeElement.getAttribute('name'),null,event.target.dataset.key);
    } 
  }

  onCartUpdate() {
    if(document.body.classList.contains('template-cart')){    
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, selling_plan, name,properties,key) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      selling_plan,
      properties,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
console.log('line',line);
    const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    console.log('lineItem',lineItem);
    let subProductKey = lineItem.querySelector('cart-remove-button').dataset.mainProductKey != undefined ? lineItem.querySelector('cart-remove-button').dataset.mainProductKey : '';

    // console.log('subProductKey',subProductKey)

    let lineBundle;
    if(lineItem.querySelector('cart-remove-button').dataset.mainBundleProduct == "true"){
      lineBundle = lineItem.querySelector('cart-remove-button').dataset.bundleId;
    }
    console.log('innnnnnnnn');
    
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        console.log('jdihdihihhd');

        
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });

        if(document.querySelector('[data-only-free-product]') != null){ // remove alone free product from cart
          document.querySelector('[data-only-free-product] cart-remove-button').click();
        }
        if(document.querySelectorAll('[data-remove-custom-plan]').length){ // remove free product from cart if subscription is removed
          document.querySelectorAll('[data-remove-custom-plan]').forEach(function(ele){
            ele.querySelector('cart-remove-button').click();
          })
        }
        
        // console.log('lineee',document.querySelector('[data-key="'+subProductKey+'"]'),subProductKey);
        // // remove subproduct on main product removal
        // if(subProductKey != ''){
        //   document.querySelector('cart-remove-button[data-key="'+subProductKey+'"]').click();
        // }

         // remove subproduct on main product removal
        let subProducts = document.querySelectorAll('[data-bundle-id="'+lineBundle+'"]');
        if(subProducts.length){
          // document.querySelector('cart-remove-button[data-key="'+subProductKey+'"]').click();
          // let updates = {};
          var formData = new FormData();
          
          subProducts.forEach(function(ele){
            let key = ele.dataset.key;
            formData.append("updates["+key+"]", quantity);
          })
          formData.append("sections", 'cart-drawer,cart-icon-bubble');
          this.removeGiftProducts(formData);
        }
        
        //update discount on updateqty
        // if(document.querySelector('.discount-section') != null && document.querySelector('.scDiscount__container') != null){
        //   setTimeout(function(){
        //     // console.log('hello init again');
        //     document.querySelector('cart-drawer').initCartDiscounts();
        //   },3000);
        // }

        // add upsell reinit
        let upsellATC = document.querySelector('cart-drawer').querySelectorAll('[btn-upsell-atc]')
        upsellATC.forEach(function(btn){
          btn.addEventListener('click',function(evt){
            document.querySelector('cart-drawer').addUpselltoCart(evt);
          })
        })

        // add free diet plan if subscription product is added
        if(document.querySelector('[data-free-custom-diet-plan] button') != null){
          // console.log(document.querySelector('[data-free-custom-diet-plan] button'));
          document.querySelector('[data-free-custom-diet-plan] button').click();
        }
        
        setTimeout(() => {
          if(document.querySelectorAll('[data-free-variant-id]').length){ // remove free product from cart if subscription is removed
            document.querySelectorAll('[data-free-variant-id]').forEach(function(ele){
              const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              const cartItems = ele.closest('cart-items') || ele.closest('cart-drawer-items');
              let propObj = {};
              let propInp = ele.querySelectorAll('[data-custom-properties]');
              const upsellForm = document.createElement("form");
              const qtyInput = document.createElement("input");
              qtyInput.name = 'quantity';
              qtyInput.value = ele.dataset.qty;
              const idInput = document.createElement("input");
              idInput.name = 'id';
              idInput.value = ele.dataset.freeVariantId;
              upsellForm.appendChild(qtyInput);
              upsellForm.appendChild(idInput);
              let propInput;
              
              propInp.forEach(function(inp){
                propInput = document.createElement("input");
                propInput.name = inp.name;
                propInput.value = inp.value;
                upsellForm.appendChild(propInput);
              })
             
              document.querySelector('cart-drawer').replaceCartProduct(ele.dataset.lineId,0,upsellForm,cart,null);
            })
          }
        }, 700);
      })
      .catch(() => {
        console.log('ssasasassasasas');
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        function getCookie(name) {
            var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return v ? v[2] : null;
        }
        if(getCookie('discount_code')){
          $('.discount-code-apply-wrapper').find('#discount-code-input').val(getCookie('discount_code'));
          $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');
        }
        this.disableLoading(line);
      });
  }

  
  removeGiftProducts(formData){
    let cart  = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(response => {
      // console.log('heiiii');
      cart.renderContents(response);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
